/* global localStorage */
import React, { Component } from "react";
import cn from "classnames";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { checkLogin, login } from "../actions/auth";
import { alert } from "../actions/alerts";
import Loading from "../components/Loading";

@connect(({ auth }) => auth)
export default class Login extends Component {
  state = {
    email: "",
    password: "",
    hasError: false,
  };

  componentDidMount() {
    this.checkLoggedInState();
  }

  onChange = (e) => {
    this.setState({
      hasError: false,
      [e.target.id]: e.target.value,
    });
  };

  checkLoggedInState = async () => {
    const {
      location: { state },
    } = this.props;

    if (localStorage.getItem("accessToken") === null) return;

    // check if already logged in
    const loggedIn = await checkLogin({}, function () {
      /* noop */
    });
    if (loggedIn) {
      const redirect = (state && state.from.pathname) || "/";
      window.location.replace(redirect);
    }
  };

  handleLogin = async (e) => {
    e.preventDefault();
    const {
      dispatch,
      location: { state },
    } = this.props;
    const { email, password } = this.state;
    const redirect = (state && state.from.pathname) || "/";
    const { error } = await dispatch(
      login(email, password, redirect, dispatch)
    );
    if (error) {
      dispatch(alert({ message: error, type: "error" }));
      this.setState({ hasError: true });
    }
  };

  render() {
    const { hasError, email, password } = this.state;
    const { loading } = this.props;

    return (
      <div>
        <span className="sign-up-link">
          <Link to="/signup">Sign up</Link>
        </span>
        <div className="absolute-center login-window">
          <div className="branding-logo" />
          <form className={cn({ hasError })} onSubmit={this.handleLogin}>
            <h1>Sign In</h1>
            <fieldset className={cn({ animated: hasError, shake: hasError })}>
              <input
                className="login-email form-control"
                placeholder="Email Address"
                type="email"
                id="email"
                value={email}
                onChange={this.onChange}
              />
              <input
                className="login-password form-control"
                placeholder="Password"
                type="password"
                id="password"
                value={password}
                onChange={this.onChange}
              />
            </fieldset>
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? <Loading /> : "Sign In"}
            </button>
            <Link to="/reset">Reset Password</Link>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/containers/Login.js